import { IEntityBase } from './entityBase';

export type BookingPaymentStatus =
  | 'PROCESSING'
  | 'FAILED'
  | 'ONGOING'
  | 'WAITING'
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED'
  | 'CANCELED'
  | 'VALIDATING'
  | 'PAYMENT_EXTERNAL'
  | 'PAYMENT_EXTERNAL_PENDING'
  | 'PAYMENT_HOTEL';

export enum PrettyBookingPaymentStatus {
  PROCESSING = 'Registrando pagamento',
  FAILED = 'Falha no registro do pagamento',
  ONGOING = 'Pagemento em andamento',
  WAITING = 'Aguardando pagamento',
  APPROVED = 'Pagamento aprovado',
  PENDING = 'Processando pagamento',
  REJECTED = 'Pagamento rejeitado',
  CANCELED = 'Pagamento cancelado',
  VALIDATING = 'Validando pagamento',
  PAYMENT_EXTERNAL = 'Pago ao club',
  PAYMENT_EXTERNAL_PENDING = 'A ser pago no club',
  PAYMENT_HOTEL = 'Miscellaneous',
}

export interface IBookingCancellationHistoryBase extends IEntityBase {
  reason?: string;
  exceedCancellationDeadline: boolean;
  minutesBeforeScheduleStart: number;
  userId: string;
  bookingId: string;
}

export interface IBookingPaymentItemBase extends IEntityBase {
  activityScheduleId: string;
  brand?: string;
  costCenter: string;
  minUserExperience: number;
  name: string;
  price: number;
  productCode: string;
  productType: string;
  quantity: number;
  sellerId?: string | null;
  type: 'MEMBER_BOOKING_CHARGE' | 'GUEST_BOOKING_CHARGE' | 'ITEM_CHARGE';
  waveSide?: 'COMBO' | 'LEFT' | 'RIGHT' | null;
  paymentId: string;
}

export interface IBookingPaymentBase extends IEntityBase {
  authorizedAt?: string;
  installments: number;
  orderRef?: string;
  orderId?: string;
  status: BookingPaymentStatus;
  type: string;
  bookingId: string;
  cardId?: string;
  userId: string;
}

export interface IBookingCheckinBase extends IEntityBase {
  bookingId: string;
  userId: string;
}

export type BookingSessionBlockReason =
  | 'WEATHER_CONDITIONS'
  | 'POWER_OUTAGE'
  | 'TECHNICAL_ISSUES'
  | 'OTHER';

export type BookingSessionBlockStatus = 'ACTIVE' | 'UNBLOCKED';

export type BookingSessionBlockBookingStatus =
  | 'SUSPENDED'
  | 'PENDING_CONFIRMATION'
  | 'CONFIRMED_BY_USER'
  | 'DECLINED_BY_USER'
  | 'MANUAL_HANDLING';

export interface IBookingSessionBlockBase extends IEntityBase {
  activityId: string;
  blockedDate: string;
  customReason?: string | null;
  notificationMessage: string;
  reason: BookingSessionBlockReason;
  status: BookingSessionBlockStatus;
  unblockedAt?: string | null;
  ventureId: string;
}

export interface IBookingSessionBlockBookingBase extends IEntityBase {
  answeredAt?: string | null;
  block: IBookingSessionBlockBase;
  blockId: string;
  bookingId: string;
  notifiedAt?: string | null;
  status: BookingSessionBlockBookingStatus;
  userId: string;
}

export interface IBookingItemBase extends IEntityBase {
  activityItemId: string;
  description?: string;
  name: string;
  bookingId: string;
}

export interface IBookingScheduleItemBase extends IEntityBase {
  scheduleItemId: string;
  description?: string;
  name: string;
  price?: number | null;
  totalAmount: number;
  bookingId: string;
  isRequired: boolean;
  userId?: string | null;
}

export interface IBookingBase extends IEntityBase {
  activityScheduleId: string;
  bookedById?: string | null;
  bookedDate: string;
  bookingPrice?: number;
  description?: string;
  endTime?: string;
  isActive: boolean;
  exceededCancellationDeadline: boolean;
  isExpired?: boolean;
  startTime?: string;
  titularUserId: string;
  userId: string;
  deletedAt?: string;
  sessionBlockBookings?: IBookingSessionBlockBookingBase[];
}
